
import React from 'react';

const IntroSection: React.FC = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold text-gray-900 mb-8">
            OSHA Consulting: Navigating Safety Requirements
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed mb-8">
            The health and safety of your employees is not only a legal requirement but also a cornerstone of maintaining a productive and positive workplace culture. The Occupational Safety and Health Administration (OSHA) sets stringent regulations to safeguard workers across various industries. However, navigating these complex requirements can be challenging.
          </p>
          <p className="text-lg text-gray-700 leading-relaxed">
            At HP Inc consulting services, we've designed our comprehensive services to help you comply with OSHA standards, eliminate hazards, and foster a safety culture in your working environment.
          </p>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;
